import { Controller } from 'stimulus';

/**
 * Report schedule VIP-selection picker. Each mode is an option card (mirroring
 * the report-creation wizard's source step). Selecting a card's radio highlights
 * it and reveals its inline detail (the building/floor table or the individual-VIP
 * select), hiding the others.
 *
 * The chosen mode is authoritative on the server, which only reads the selected
 * mode's fields, so this controller is purely presentational — it does not disable
 * hidden inputs.
 *
 * @target optionCard - each mode card; holds a radio and an optional detail.
 */
export default class extends Controller {
  static targets = ['optionCard'];

  connect() {
    this.toggle();
  }

  toggle() {
    const selected = this.element.querySelector(
      'input[name="report_schedule[vip_selection_mode]"]:checked'
    )?.value;

    this.optionCardTargets.forEach((card) => {
      const radio = card.querySelector('input[type="radio"]');
      const active = !!radio && radio.value === selected;

      card.classList.toggle('border-primary', active);

      const detail = card.querySelector(
        '[data-report-schedule-vip-selection-target="optionDetail"]'
      );
      if (detail) detail.classList.toggle('d-none', !active);
    });
  }
}
